import { render, staticRenderFns } from "./Acciones.vue?vue&type=template&id=079ef869&scoped=true"
import script from "./Acciones.vue?vue&type=script&lang=js"
export * from "./Acciones.vue?vue&type=script&lang=js"
import style0 from "./Acciones.vue?vue&type=style&index=0&id=079ef869&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "079ef869",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\wamp64\\www\\signar-frontend\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('079ef869')) {
      api.createRecord('079ef869', component.options)
    } else {
      api.reload('079ef869', component.options)
    }
    module.hot.accept("./Acciones.vue?vue&type=template&id=079ef869&scoped=true", function () {
      api.rerender('079ef869', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/otros-documentos/Acciones.vue"
export default component.exports